import React, { useState } from "react";
import PropTypes from "prop-types";
import { Grid, GridItem } from "@domestika-dev/prudencio/dist/atoms/Layout";
import { StarsReview } from "@domestika-dev/prudencio/dist/molecules/StarsReview";
import { LiveFeedbackQuestionText } from "./LiveFeedbackQuestionText";

export const LiveFeedbackRatingQuestion = ({ question, maxRating, onValueChanged }) => {
  const [, setAnswer] = useState();

  const onAnswerChanged = (value) => {
    setAnswer(value);
    onValueChanged({ value });
  };

  return (
    <Grid gridRowGap={[3, 3, 3]} gridTemplateColumns="repeat(5, minmax(40px, 1fr))">
      <GridItem gridColumn="1 / span 8" gridRow="1">
        <LiveFeedbackQuestionText question={question} />
      </GridItem>
      <GridItem gridColumn="1 / span 8" gridRow="2">
        <StarsReview
          onClick={(value) => {
            onAnswerChanged(value);
          }}
          maxRating={maxRating}
        />
      </GridItem>
    </Grid>
  );
};

LiveFeedbackRatingQuestion.propTypes = {
  question: PropTypes.string.isRequired,
  maxRating: PropTypes.number.isRequired,
  onValueChanged: PropTypes.func.isRequired,
};

export default LiveFeedbackRatingQuestion;
